import { PRODUCT_SET } from '../../constants';

export const BULLET_CLASS_NAME = `${PRODUCT_SET}__bullet`;
export const BULLET_ACTIVE_CLASS_NAME = `${BULLET_CLASS_NAME}-active`;
